'use strict';

import vex from 'vex-js';
import VexDialog from 'vex-js/js/vex.dialog';

$('[data-modal-description]').on('click', function(e) {
    e.preventDefault();
    vex.defaultOptions.className = 'vex-theme-os';

    let currentDescription = $(this).data('modal-description'),
        targetUrl = $(this).attr('href');

    VexDialog.open({
        message: '',
        input: '<label>Description:</label><input name="description" type="text" value="' + currentDescription + '"/>',
        buttons: [
            $.extend({}, VexDialog.buttons.YES, {
                text: 'Submit'
            }), $.extend({}, VexDialog.buttons.NO, {
                text: 'Cancel'
            })
        ],
        callback: function(data) {
            if (data === false) {
                return;
            }

            let request = $.ajax({
                url: targetUrl,
                method: "POST",
                data: data
            });

            request.done(function( ) {
                location.reload();
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/components/modal.js